<mat-toolbar class="matp-header !matp-bg-primary !tw-text-white">
  <div
    class="matp-sidenav-btn-area tw-text-center tw-ml-[-1rem] tw-h-full tw-p-2"
  >
    <button
      mat-icon-button
      class="!tw-p-1"
      (click)="toggleSidenav()"
      [hidden]="!sidenav"
    >
      <mat-icon class="!tw-h-10 !tw-w-10 tw-text-[2.5rem]">menu</mat-icon>
    </button>
  </div>

  <a routerLink="/" class="tw-h-full tw-items-center">
    <img
      src="assets/img/macnicaTracks_Logo_RGB_white.png"
      alt="ロゴ"
      class="tw-h-auto tw-max-h-full tw-w-full tw-max-w-80"
    />
  </a>

  <span class="tw-flex-1"></span>

  @if (notificationEnable) {
    <button
      mat-icon-button
      [matMenuTriggerFor]="notificationMenu"
      (click)="markAsRead()"
    >
      @if (unreadCount) {
        <mat-icon
          matBadgePosition="below after"
          [matBadge]="unreadCount >= 5 ? '5+' : unreadCount"
          matBadgeColor="warn"
          aria-hidden="false"
          >notifications</mat-icon
        >
      } @else {
        <mat-icon
          matBadgePosition="below after"
          matBadgeColor="warn"
          aria-hidden="false"
          >notifications</mat-icon
        >
      }
    </button>
    <mat-menu
      #notificationMenu="matMenu"
      class="tw-w-[400px] !tw-max-w-[400px]"
      (closed)="closeNotificationMenu()"
    >
      <mat-list role="list" class="tw-overflow-y-auto tw-max-h-[500px]">
        <mat-list-item role="listitem" class="!tw-h-10">
          <div class="tw-text-lg tw-font-bold">掲示板メッセージ</div>
        </mat-list-item>
        <mat-divider></mat-divider>
        @for (notification of notificationList; track notification.messageId) {
          <mat-list-item
            role="listitem"
            class="!tw-h-20 hover:!tw-bg-[#F5F5F5]"
            (click)="openNotificationDetailDialog(notification, $event)"
          >
            <div
              class="tw-flex"
              [ngClass]="
                notification.isRead ? 'tw-text-gray-500' : 'tw-text-black'
              "
            >
              <div class="tw-truncate tw-w-56">
                {{ notification.title }}
              </div>
            </div>
            <div class="tw-flex">
              <div
                class="tw-truncate tw-w-56 tw-text-xs"
                [ngClass]="
                  notification.isRead ? 'tw-text-gray-500' : 'tw-text-black'
                "
              >
                {{ notification.content }}
              </div>
              <div
                class="tw-text-xs tw-ml-auto"
                [ngClass]="
                  notification.isRead ? 'tw-text-gray-500' : 'tw-text-black'
                "
              >
                {{ notification.releaseAt | date: " yyyy/MM/dd HH:mm" }}
              </div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
        }
      </mat-list>
      <div
        class="tw-text-center tw-flex tw-h-12 tw-items-center tw-justify-center"
      >
        @if (loading) {
          <mat-spinner diameter="30" class="tw-mr-8"></mat-spinner>
        } @else {
          <div class="tw-w-[82px] tw-h-[50px]"></div>
        }
        <button
          id="btn-look-more-notification"
          mat-raised-button
          mat-dialog-close
          color="primary"
          class="tw-w-40 tw-mr-20"
          (click)="updateNotificationList($event)"
          [disabled]="loading"
        >
          <mat-icon>search</mat-icon>
          もっと見る
        </button>
      </div>
    </mat-menu>
  }

  <button mat-icon-button [matMenuTriggerFor]="helpMenu">
    <mat-icon>help</mat-icon>
  </button>
  <mat-menu #helpMenu="matMenu">
    <button mat-menu-item disabled>バージョン情報：{{ version }}</button>
    <button mat-menu-item (click)="getTracksManual()">
      マニュアルダウンロード
    </button>
  </mat-menu>

  <button mat-icon-button [matMenuTriggerFor]="userMenu">
    <mat-icon>person</mat-icon>
  </button>
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="openUserSetting()">ユーザー設定</button>
    <button mat-menu-item (click)="logout()">ログアウト</button>
  </mat-menu>
</mat-toolbar>
